module.exports = __webpack_public_path__ + "static/img/icon0.0e35986.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon0.png
// module id = SMDe
// module chunks = 1